var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "opt-group" },
    [
      _c(
        "el-dropdown",
        {
          staticClass: "menu-buttons",
          attrs: { trigger: "click" },
          on: { command: _vm.handleToDetails },
        },
        [
          _c("span", { staticClass: "el-dropdown-link" }, [
            _vm._v("\n      Action\n    "),
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _vm.record.status !== 0 &&
              _vm.record.status !== 1 &&
              _vm.record.status !== 4 &&
              _vm.record.status !== 5 &&
              _vm.record.status !== 8 &&
              _vm.record.status !== 9 &&
              _vm.record.status !== 12 &&
              _vm.record.status !== 7 &&
              _vm.record.status !== 3 &&
              _vm.record.status !== 11
                ? _c(
                    "el-dropdown-item",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        color: "rgba(255,132,91,1)",
                      },
                      attrs: {
                        command: "Submit",
                        icon: "el-icon-document-checked",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            position: "relative",
                            left: "-4px",
                            top: "-2px",
                            color: "black",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("\n            SUBMIT\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.record.status !== 4 &&
              _vm.record.status !== 9 &&
              _vm.record.status !== 12 &&
              _vm.record.status !== 7 &&
              _vm.record.status !== 3
                ? _c(
                    "el-dropdown-item",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        color: "rgba(255,132,91,1)",
                      },
                      attrs: { command: "Change", icon: "el-icon-refresh" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            position: "relative",
                            left: "-4px",
                            top: "-2px",
                            color: "black",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("\n            CHANGE\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dropdown-item",
                {
                  staticStyle: { "font-size": "18px", color: "#0099E5" },
                  attrs: { command: "Preview", icon: "el-icon-search" },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "relative",
                        left: "-2px",
                        top: "-2px",
                        color: "black",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("\n            VIEW\n          ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.record.status !== 4 &&
              _vm.record.status !== 9 &&
              _vm.record.status !== 12 &&
              _vm.record.status !== 7 &&
              _vm.record.status !== 3
                ? _c(
                    "el-dropdown-item",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        color: "rgba(222,34,22,1)",
                      },
                      attrs: { command: "Cancel", icon: "el-icon-close" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            position: "relative",
                            left: "-5px",
                            top: "-2px",
                            color: "black",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("\n            CANCEL\n        ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dropdown-item",
                {
                  staticStyle: {
                    "font-size": "18px",
                    color: "rgba(69,223,86,1)",
                  },
                  attrs: { command: "Copy", icon: "el-icon-document-copy" },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "relative",
                        left: "-3px",
                        top: "-2px",
                        color: "black",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("\n            COPY\n        ")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }